// extracted by mini-css-extract-plugin
export default {"container":"xp-z","ratingLayout":"yp-z","ratingLabel":"zp-z","nonInteractiveRatingLabel":"Ap-z"};